import React, {Fragment} from 'react';
import i18n from '../../../utilities/i18n';
import {Checkbox} from '../../checkboxes/checkbox';
import {Button, ButtonType} from '../../button/button';
import {ErrorBox} from '../../errorbox/errorbox';
import {TasklistStartIcon} from '@navikt/aksel-icons';

const Bekreft = (props) => {
  return (
    <section>
      {props.lisensArter.filter(art => art.arter === 1).filter(art => !props.eksisterendeLisenser.includes(art)).length > 0 ?
        <Fragment>
          <h2 className='pageHeading'>{i18n.t('lisensRegistrering:hvilkeArter')}{props.jaktaar}</h2>
          <hr/>
          <p className='stepCount'>{i18n.t('lisensRegistrering:steg2')}</p>
          {props.eksisterendeLisenser.length !== 0 &&
          <div className='lisensListe'>
            <h3>{i18n.t('lisensRegistrering:tidligereLisenser')}</h3>
            {props.eksisterendeLisenser
                .map((art) => (
                  <div key={art.artId} className='artsListeElement'>
                    <Checkbox checkboxId={art.artId}
                              text={i18n.t('felles:' + art.beskrivelse)}
                              disabled={true}
                              isChecked={true}/>
                  </div>))}
          </div>}
          <h3>{i18n.t('lisensRegistrering:valgte')}</h3>
          <div className='lisensListe'>
            {props.lisensArter
                  .filter((art) => !props.eksisterendeLisenser.includes(art) && art.arter && art.arter === 1)
                  .map((art) => (
                    <div key={art.artId} className='artsListeElement'>
                      <Checkbox checkboxId={art.artId}
                                text={i18n.t('felles:' + art.beskrivelse)}
                                testprop={art.arter}
                                disabled={true}
                                isChecked={true}/>
                    </div>
                  ))}
          </div>
          <Button type={ButtonType.PRIMARY}
                  icon={<TasklistStartIcon fontSize="1.5rem" />}
                  onClick={props.updateLicence}
                  buttonId="confirmButton">
            {i18n.t('lisensRegistrering:fullfor')}
          </Button>
          <Button type={ButtonType.SECONDARY}
                  onClick={props.back}
                  buttonId="backToRegButton">
            {i18n.t('lisensRegistrering:tilbake')}
          </Button>
          <Button type={ButtonType.SIMPLE}
                  onClick={props.abort}
                  buttonId="abortButton">
            {i18n.t('lisensRegistrering:avbryt')}
          </Button>
          <hr/>
        </Fragment>
            :
        <Fragment>
          <h2>{i18n.t('lisensRegistrering:hvilkeArter')}</h2>
          <hr/>
          <p className='stepCount'>{i18n.t('lisensRegistrering:steg2')}</p>
          <ErrorBox><h3>{i18n.t('lisensRegistrering:ikkjeValgtError')}</h3></ErrorBox>
          <Button type={ButtonType.PRIMARY}
                  icon={<TasklistStartIcon fontSize="1.5rem" />}
                  onClick={() => {
                      }}
                  // Intentionaly left empty
                  disabled={true}
                  buttonId="confirmButton">
            {i18n.t('lisensRegistrering:fullfor')}
          </Button>
          <Button type={ButtonType.SECONDARY}
                  onClick={props.back}
                  buttonId="backToRegButton">
            {i18n.t('lisensRegistrering:tilbake')}
          </Button>
          <Button type={ButtonType.SIMPLE}
                  onClick={props.abort}
                  buttonId="abortButton">
            {i18n.t('lisensRegistrering:avbryt')}
          </Button>
          <hr/>
        </Fragment>}
    </section>
  );
};

export default Bekreft;
